export default "__VITE_ASSET__e957dc84__"